import React from "react";

const DEFAULT_LABELS = {
  "6": "Clause 6 - Planning",
  "7": "Clause 7 - Support",
  "8": "Clause 8 - Operation",
  "9": "Clause 9 - Performance",
  "10": "Clause 10 - Improvement",
};

export default function FixedIsoClauseField({ clause, labels = {} }) {
  const clauseNumber = String(clause || "").trim();
  const clauseLabel = String(labels[clauseNumber] || DEFAULT_LABELS[clauseNumber] || "").trim();
  const value = clauseNumber
    ? (clauseLabel ? `${clauseNumber} - ${clauseLabel}` : `Clause ${clauseNumber}`)
    : "Loading assigned clause...";

  return (
    <label className="settings-field">
      <span>ISO clause</span>
      <input
        className="fixed-iso-clause"
        value={value}
        readOnly
        aria-readonly="true"
        title="This clause is fixed for this register."
      />
    </label>
  );
}